<template>
  <v-layout justify-center class="position--fixed width-100" style="bottom: 0; z-index: 1">
    <v-bottom-navigation
      v-if="isCreditAvailable"
      :value="selectedNavi"
      grow
      height="57"
      color="primary"
      class="elevation-0"
      max-width="500"
    >
      <v-btn width="0" height="0" class="d-none"></v-btn>
      <v-btn
        v-for="navi in navigations"
        :key="navi.routeName"
        :value="navi.routeName"
        :disabled="navi.disabled"
        @click="moveTo(navi)"
        min-width="50"
        class="navi-button"
      >
        <span class="navi__text"> {{ navi.text }}</span>

        <img
          v-if="navi.image"
          class="navi__logo"
          :src="require(`@/assets/images/icons/${navi.image}`)"
        />
        <v-icon v-else class="navi__logo">{{ navi.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isCreditAvailable']),
    ...mapGetters('contract', ['isServiceAvailable']),
    ...mapState('bnpl', ['availableAmount']),
    selectedNavi() {
      return this.$route.name
    },
    navigations() {
      const navi = [
        { routeName: 'main', text: '홈', icon: 'mdi-home', image: null },
        {
          routeName: 'wholesaler/find',
          text: '사입비 신청',
          icon: 'mdi-pencil',
          image: null,
          disabled: !this.isPaymentAvailable,
        },
        { routeName: 'settlement', text: '매출 정산', icon: 'mdi-receipt', image: null },
        { routeName: 'my', text: '마이페이지', icon: 'mdi-account', image: null },
      ]

      // if (!this.isPaymentAvailable) {
      //   return navi.filter((e) => e.routeName !== 'wholesaler/find')
      // }

      return navi
    },
    isPaymentAvailable() {
      return this.isServiceAvailable === true && this.availableAmount.available > 0
    },
  },
  mounted() {
    const footers = document.getElementsByTagName('footer')
    const footer = footers[footers.length - 1]
    footer.classList.add('navi-bottom')
    document.getElementsByTagName('body')[0].classList.add('navi-bottom')
  },
  destroyed() {
    const footers = document.getElementsByTagName('footer')
    const footer = footers[footers.length - 1]
    footer.classList.remove('navi-bottom')
    document.getElementsByTagName('body')[0].classList.remove('navi-bottom')
  },
  methods: {
    async moveTo(navi) {
      if (this.$route.name === navi.routeName) {
        return
      }
      await this.$router.push({ name: navi.routeName })
    },
  },
}
</script>

<style>
footer.navi-bottom {
  padding-bottom: 56px !important;
}
</style>

<style lang="scss" scoped>
.v-bottom-navigation {
  border-top: 1px solid $gray-20;
}

.navi {
  &__text {
    color: inherit;
    font-size: 10px !important;
  }

  &__logo {
    max-width: 24px;
    max-height: 24px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

button:not(.v-btn--active) .v-btn__content .v-icon {
  color: $gray-60;
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: $gray-20 !important;
}

.navi-button {
  height: inherit !important;
  background-color: transparent !important;
}
</style>
